module.exports = __webpack_public_path__ + "static/media/logo-camarajaguarari.f8098e59.png";